import asCatalog from './components/asCatalog.js';
import asCatalogSections from './components/asCatalogSections.js';
import asMyList from './components/asMyList.js';
// import asCatalogSections from '../components/asCatalogSections.js';
// import asCollectionInfoSheets from '../components/asCollectionInfoSheets';
import asInfoSheet from './components/asInfoSheet';
import BarcelonaBrandsInfoSheet from './templates/BarcelonaBrands/BarcelonaBrandsInfoSheet.js';
import BarcelonaBrandsInfoSheetFinal from './templates/BarcelonaBrands/BarcelonaBrandsInfoSheetFinal.js';
// import BerkmannInfoSheet from './Berkmann/BerkmannInfoSheet/BerkmannInfoSheet';
// import InfoSheet from './Bottlebooks/InfoSheets/InfoSheetChardonnay';
// import InfoSheetWithQRCode from './Bottlebooks/InfoSheetWithQRCode/InfoSheetWithQRCode';
// import InfoSheetWithQRCodeDetailed from './Bottlebooks/InfoSheetWithQRCode/InfoSheetWithQRCodeDetailed';
// import CaliforniaCatalog from './California/CaliforniaCatalog/CaliforniaCatalog';
// import CaliforniaTableSignBase from './California/TableSigns/CaliforniaTableSignBase';
// import CaliforniaTableSignEurope from './California/TableSigns/CaliforniaTableSignEurope';
// import CaliforniaTableSignWithWashington from './California/TableSigns/CaliforniaTableSignWithWashington';
import ExhibitorQrCodeLabels8164 from './templates/Bottlebooks/ExhibitorQrCodeLabels8164';

import OneExhibitorPerPage from './templates/California/OneExhibitorPerPage';
import QRCodeLabels from './templates/California/QRCodeLabels';
import TwoExhibitorsPerPage from './templates/California/TwoExhibitorsPerPage';
import TwoExhibitorsPerPageList from './templates/California/TwoExhibitorsPerPageList';
import * as LKBurgenland from './templates/LKBurgenland';
import MaximeHerkunftKatalog from './templates/MaximeHerkuft/MaximeHerkunftKatalog';

import MaximeHerkunftTableSign from './templates/MaximeHerkuft/MaximeHerkunftTableSign';
import MeiningerCatalog from './templates/Meininger/Finest100';
import RoussillonCatalog from './templates/Roussillon/RoussillonCatalog';
import * as Urbanihof from './templates/urbanihof.at';
import TastingBooklet from './templates/Bottlebooks/TastingBooklet';
// import ChileCatalog from './Chile/ChileCatalog';
// import InfoSheetColemanWine from './CustomerInfoSheets/ColemanWine';
// import InfoSheetJusteriniBrooks from './CustomerInfoSheets/JusteriniBrooks';
// import InfoSheetTheWinePeople from './CustomerInfoSheets/TheWinePeople';
// import PfalzInfoSheet from './Pfalz/PfalzInfoSheet/PfalzInfoSheet';
import * as VieVinum from './templates/VieVinum';
import * as WeinBurgenland from './templates/WeinBurgenland';

// This follows the naming conventions from Classic
const templates = {
  // 'brn:print:58e231362373441932baed86:uk.co.berkmann.infoSheetReact':
  //   asInfoSheet(BerkmannInfoSheet),
  // 'brn:print:59526a87c7d192b57c814726:org.wineinstitute.californiaTableDisplay2022':
  //   asCatalogSections(CaliforniaTableSignBase),
  // 'brn:print:59526a87c7d192b57c814726:org.wineinstitute.californiaTableDisplay2021':
  //   asCatalogSections(CaliforniaTableSignEurope),
  // 'brn:print:59526a87c7d192b57c814726:org.wineinstitute.californiaTableDisplayWashington2022':
  //   asCatalogSections(CaliforniaTableSignWithWashington),
  // 'brn:print:59526a87c7d192b57c814726:org.wineinstitute.standard-react':
  //   asCatalogSections(CaliforniaCatalog),
  'brn:tastingList:59526a87c7d192b57c814726:org.wineinstitute.oneExhibitorPerPage':
    asMyList(OneExhibitorPerPage),
  'brn:tastingList:59526a87c7d192b57c814726:org.wineinstitute.twoExhibitorsPerPageList':
    asMyList(TwoExhibitorsPerPageList),
  'brn:print:59526a87c7d192b57c814726:org.wineinstitute.twoExhibitorsPerPage':
    asMyList(TwoExhibitorsPerPage),
  'brn:print:59526a87c7d192b57c814726:org.wineinstitute.qrCodeLabels':
    asCatalog(QRCodeLabels),
  'brn:print:5f6c8ff918b64f467d993269:de.meininger.baseCatalog':
    asMyList(MeiningerCatalog),
  'brn:print:5e1f6599f5daf879e5402bb5:de.maxime-herkunft.baseCatalog': asMyList(
    MaximeHerkunftKatalog
  ),
  'brn:print:5e1f6599f5daf879e5402bb5:de.maxime-herkunft.tableSign':
    asCatalogSections(MaximeHerkunftTableSign),
  'brn:print:609a621961ff372bd55ded2d:com.winesofroussillon.baseCatalog':
    asMyList(RoussillonCatalog),
  // 'brn:print:59ad5dcec5862663cefd682d:com.justerinis.infoSheetReact':
  //   asInfoSheet(InfoSheetJusteriniBrooks),
  // 'brn:print:5f33a4c55853c71ea0feb03e:de.pfalz.infoSheetReact':
  //   asInfoSheet(PfalzInfoSheet),
  // 'brn:print:bottlebooks:me.bottlebooks.infoSheetWithQRCodes':
  //   asCollectionInfoSheets(InfoSheetWithQRCode),
  // 'brn:print:bottlebooks:me.bottlebooks.infoSheetWithQRCodesDetailed':
  //   asCollectionInfoSheets(InfoSheetWithQRCodeDetailed),
  // 'brn:print:bottlebooks:me.bottlebooks.infoSheet2021': asInfoSheet(InfoSheet),
  'brn:print:bottlebooks:me.bottlebooks.exhbitorQRCodeLabels': asCatalog(
    ExhibitorQrCodeLabels8164
  ),
  // 'brn:print:58d2b35cd2b814705f1ed453:com.twpwines.infoSheet': asInfoSheet(
  //   InfoSheetTheWinePeople
  // ),
  // 'brn:print:5c78f5ed1e23a3bf984e8ca6:com.colemanwine.infoSheet':
  //   asInfoSheet(InfoSheetColemanWine),
  // 'brn:print:58f62ae4905d050f39902afd:org.winesofchile.catalog':
  //   asCatalogSections(ChileCatalog),
  'brn:print:5abc9cb9d845997f6924c80a:com.barcelonabrands.infoSheet':
    asInfoSheet(BarcelonaBrandsInfoSheet),
  'brn:print:5abc9cb9d845997f6924c80a:com.barcelonabrands.infoSheetFinal':
    asInfoSheet(BarcelonaBrandsInfoSheetFinal),

  'Bottlebooks/TastingBooklet': asMyList(TastingBooklet),

  'brn:print:619697e4831d3e0f270310c1:at.lko.bgld.form':
    LKBurgenland.EinreichungSheet,
  'brn:print:5a5385acfef95b36d5add5b8:at.vievinum.2022.catalog':
    VieVinum.Catalog,
  'brn:print:5a5385acfef95b36d5add5b8:at.vievinum.2022.catalogNoBleed':
    VieVinum.CatalogNoBleed,
  'brn:print:5a5385acfef95b36d5add5b8:at.vievinum.2022.myList': VieVinum.MyList,
  'brn:print:5a5385acfef95b36d5add5b8:at.vievinum.2022.preview':
    VieVinum.Preview,
  'brn:print:5a16e716c93586389fd8e9e6:at.weinburgenland.2022.award':
    WeinBurgenland.AwardSheet,
  'brn:print:5a6e3356345b3b664a107c9a:at.urbanihof.2022.infosheet':
    Urbanihof.InfoSheet,
  'urbanihof.at/infosheet': Urbanihof.InfoSheet,

  // These lists are specific to Gatsby directories:
  'VieVinum/VieVinumMyList': VieVinum.MyList,
};

export default templates;
